const popupsShownStorageKey = 'popups-shown';

export const getStoredPopupsShown = () => {
  let popupsShown: Record<number, number> = {};
  try {
    const rawPopupsShown = localStorage.getItem(popupsShownStorageKey);
    if (rawPopupsShown) {
      popupsShown = JSON.parse(rawPopupsShown);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  return popupsShown;
};

export const getPopupShowCount = (popupId: number) => {
  const popupsShown = getStoredPopupsShown();
  return popupsShown[popupId] ?? 0;
};

export const incrementPopupShowCount = (popupId: number) => {
  const popupsShown = getStoredPopupsShown();
  popupsShown[popupId] = (popupsShown[popupId] ?? 0) + 1;
  localStorage.setItem(popupsShownStorageKey, JSON.stringify(popupsShown));
};
